<template>
  <div class="pt-15">
<!--    <div-->
<!--      class="pa-4 ma-auto"-->
<!--      style="-->
<!--        font-size: 8px;-->
<!--        width: 370px;-->
<!--        color: #315ed9;-->
<!--        border: 1px solid #315ed9;-->
<!--        border-radius: 8px;-->
<!--      "-->
<!--    >-->
<!--      B-cmsはこの度「MATTRZ Base」に名称を変更しました。<br />-->
<!--      なお、現在ご利用いただいているサービス内容等に変更はございません。<br />-->
<!--      今後ともサービスの充実を図って参りますので、変わらぬご愛顧を賜りますよう、宜しくお願い申し上げます。-->
<!--    </div>-->
    <MattrzBaseLogo width="350" />
    <div class="pa-4 mx-auto my-5" style="width: 400px">
      <SignInContainer />
      <router-link class="d-inline-block mt-5" to="/user_auths/password/new">
        パスワードを忘れた場合
      </router-link>
    </div>
  </div>
</template>
<script>
import SignInContainer from '/src/container/pages/SignInContainer'
import MattrzBaseLogo from '/src/components/uiParts/images/MattrzBaseLogo'

export default {
  name: 'SignIn',
  components: {
    SignInContainer,
    MattrzBaseLogo
  },
  methods: {
    siteName () {
      return window.location.host.split('.')[0]
    }
  }
}
</script>

<style scoped>
a:hover {
  text-decoration: underline;
}
</style>
